import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export interface LscCollapsibleSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  testId?: string;
  badge?: React.ReactNode;
  variant?: 'card' | 'plain';
}

const LscCollapsibleSection: React.FC<LscCollapsibleSectionProps> = ({
  title,
  subtitle,
  children,
  defaultExpanded = false,
  testId,
  badge,
  variant = 'card',
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const shellClass =
    variant === 'card'
      ? 'rounded-xl border border-secondary-700 bg-secondary-900/60'
      : 'rounded-lg border border-secondary-800 bg-secondary-900/40';

  return (
    <section className={shellClass} data-testid={testId} id={testId}>
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-secondary-800 px-4 py-3">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-base font-semibold text-white">{title}</h2>
            {badge}
          </div>
          {subtitle ? <p className="text-xs text-secondary-500 mt-0.5">{subtitle}</p> : null}
        </div>
        <button
          type="button"
          className="btn-secondary inline-flex items-center gap-2 text-sm shrink-0"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
          data-testid={testId ? `${testId}-toggle` : undefined}
        >
          {expanded ? (
            <>
              <ChevronUp className="h-4 w-4" aria-hidden />
              Hide
            </>
          ) : (
            <>
              <ChevronDown className="h-4 w-4" aria-hidden />
              Show
            </>
          )}
        </button>
      </div>
      {expanded ? <div className="p-4 space-y-4">{children}</div> : null}
    </section>
  );
};

export default LscCollapsibleSection;
